import { keyframes, styled } from '../../Styles/stitches.config'

const loadingShimmer = keyframes({
    '0%': {
        backgroundPosition: '-468px 0',
    },
    '100%': {
        backgroundPosition: '468px 0',
    },
})

export const StyledSkeleton = styled('div', {
    animation: `${loadingShimmer} 1s linear 0s infinite forwards`,
    backgroundSize: '800px 104px',
    bgc: '$neutral200',
    display: 'inline-block',
    linearGradient:
        'to right, $colors$neutral100 8%, $colors$neutral200 18%, $colors$neutral100 33%',

    '> *': {
        opacity: 0,
        visibility: 'hidden',
    },

    variants: {
        variant: {
            circle: {
                br: '50%',
            },
            rectangle: {
                br: '$1',
            },
            text: {
                br: '$1',
                h: 16,
            },
        },
    },

    defaultVariants: {
        variant: 'text',
    },
})
